/* eslint-disable */
export const getTextFromPTagRegex = (htmlElement) => {
  return htmlElement.replace(/(<([^>]+)>)/g, '');
};

const regex = {
  imageTag: /<img([\w\W]+?)[\/]?>/g,
  imageSrc: /src\s*=\s*"(.+?)"/,
  imageAlt: /alt\s*=\s*"(.+?)"/,
  markdownImage: /!\[.*\]\(.*\)/g,
  lineBreakTag: /<br>/g,
  nbsp: /&nbsp;/g,
  leftArrow: /&lt;/g,
  rightArrow: /&gt;/g,
  amp: /&amp;/g,
  copyTextSelectorRegex: /{{((\w\.?)+)}}/g,
  amazonOrderNumber: /([0-9]{3})-([0-9]{6,9})-([0-9]{6,9})/g,
  verticalSpace: /<p>\s*&nbsp;\s*<\/p>/gi,
  aTag: /<a[\s]+href=+([^>]+)>((?:.(?!<\/a>))*.)<\/a>/g,
  aHref: /href\s*=\s*"(.+?)"/,
  aTagValue: /value\s*=\s*"(.+?)"/,
  aTagWord: /.+>(.+?)<\//,
  openParagraphTag: /<p>/g,
  closeParagraphTag: /<\/p>/g,
  specialChars: /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
};

export default regex;
